import { LEGACY_NOT_ESSENTIAL_PATHS, SWONKIE_DEV_PATHS } from '@/constants';
import { SessionQuery } from '@/graphql/generated/session.generated';

type Workspace = SessionQuery['currentWorkspace'];

/** Returns true when the workspace belongs to the SwonkieDev cohort. */
export function isSwonkieDevWorkspace(workspace: Workspace): boolean {
    return workspace.isSwonkieDev;
}

/**
 * Returns true when the workspace is on the brand pricing model: an ES/BR market
 * workspace that does not hold a legacy subscription. Resolved server-side.
 */
export function isBrandPricingWorkspace(workspace: Workspace): boolean {
    return workspace.useBrandPricing;
}

/** Workspaces on the brand model see the Fenix experience and no legacy pages. */
export const isFenixExclusive = (workspace: Workspace) => isBrandPricingWorkspace(workspace);

/**
 * Returns true when the given path is accessible for the workspace.
 * @param path The path to check access for.
 * @param workspace The current workspace of the user.
 */
export function usersPathFilterAccess(path: string | null, workspace: Workspace): boolean {
    // SwonkieDev workspaces only have access to explicitly allowed paths
    if (isSwonkieDevWorkspace(workspace)) {
        return path !== null && SWONKIE_DEV_PATHS.some((devPath) => path.startsWith(devPath));
    }

    // Fenix exclusive workspaces have access to all paths except legacy non-essential ones
    if (isFenixExclusive(workspace)) {
        return path !== null && !LEGACY_NOT_ESSENTIAL_PATHS.some((hiddenPath) => path.startsWith(hiddenPath));
    }

    return true;
}
